exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-reserved[data-v-e22a145e]{color:#fff;text-align:center;text-transform:uppercase;font-size:12px;line-height:10px;height:24px;//width:40px;background-color:#f7c560}.rotate[data-v-e22a145e]{transform:rotate(180deg)}.reader[data-v-e22a145e]{color:#72809d;font-size:16px;font-weight:400}.book[data-v-e22a145e],.reader[data-v-e22a145e]{cursor:pointer}.book[data-v-e22a145e]{color:#a7afba;font-size:13px;padding:unset;display:block}.btn-debtor.not-debtor[data-v-e22a145e]{background:#ccc}", ""]);

// exports
